<div class="pt-24 pl-72 pr-72 update-build-container">
    <app-breadcrumb class="mt-16" [items]="breadcrumbItems"></app-breadcrumb>
    <div class="header-section p-24">
      <div class="flex flex-row">
        <div class="flex flex-col mb-12">
          <mat-icon svgIcon="arrow_back" class="cursor-pointer icon-md-2" [routerLink]="['/', tenant, RouterSegments.TENANT, tenantId, RouterSegments.SOLUTION]"></mat-icon>
        </div>
        <div class="flex flex-col">
          <div class="mat-headline-5 m-0 ml-8 ml-24 mb-10">{{'SOLUTIONS.CUSTOM_PACKAGE' | transloco }}</div>
          <div *ngIf="!showSpinner" class="flex m-0 ml-8 ml-24">
            {{'SOLUTIONS.SOLUTION_NAME' | transloco }}: <span class="solution-name fw-600 pl-2 fs-16">{{solutionName}}</span>
          </div>
        </div>
      </div>
  </div>

  <div class="w-100-percent section-border p-24 mt-16">
    <div class="flex flex-row justify-between">
      <div class="flex flex-col mat-subtitle-2 justify-start fw-700 fs-12 mb-24">
        <div class="flex mb-8">{{'INSTANCE_DETAILS.UPDATE_BUILD.CUSTOM_PACKAGE' | transloco | uppercase}}
          <mat-icon svgIcon="info" class="icon-sm mt-2 ml-10" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.UPDATE_BUILD.CUSTOM_PACKAGE' | transloco"
            matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <div>
          <mat-select class="fw-500 form-select" placeholder="{{'INSTANCE_DETAILS.UPDATE_BUILD.CHOOSE' | transloco}}" [(value)]="selectedExternalPackage" panelClass="update-dropdown" (click)="onClick($event)" (selectionChange)="externalPackageChanged($event.value)">
            <div class="flex search-bar m-8"><input [(ngModel)]="searchValue" (ngModelChange)="searchChanged(searchValue)" class="fw-400 h-34 no-border pl-12" placeholder="Search" type="text">
              <span (click)="searchChanged(searchValue)" class="cursor-pointer"><mat-icon class="mr-8 icon-md icon-color mt-4 mr-10" svgIcon="search"></mat-icon></span>
            </div>
            <div class="ml-16 mr-16 mt-8 mb-8" *ngIf="filteredExternalPackages?.length === 0">{{'INSTANCE_DETAILS.UPDATE_BUILD.NO_ITEMS_FOUND' | transloco}}</div>
            <mat-option *ngFor="let package of filteredExternalPackages" [value]="package" [title]="package?.name">{{package?.name | titlecase}}</mat-option>
          </mat-select>
        </div>
        <div *ngIf="dateCreated" class="pt-4">
          <span class="fw-400 fs-14">{{'INSTANCE_DETAILS.CREATED_ON_UPDATE' | transloco}}</span>{{dateCreated | date: 'dd MMM yyyy'}}
        </div>
      </div>
      <div *ngIf="dateCreated" class="flex flex-col justify-end mb-24 search-wrapper mr-16">
        <app-search-filter (keyup)="searchChangedOnKeyUp($event)" [placeholder]="'COMPONENTS.SEARCH_COMPONENT'"></app-search-filter>
      </div>
    </div>
    <div *ngIf="isLoading">
      <div  class="loader-section flex items-center justify-center">
          <mat-spinner class="flex items-center justify-center" diameter="36"
            color="primary"
            mode="indeterminate">
          </mat-spinner>
      </div>
    </div>
    <div class="flex flex-col justify-center items-center" *ngIf="!isLoading && externalPackages?.length === 0">
      <div class="flex m-20 choose-tenant">{{'INSTANCE_DETAILS.UPDATE_BUILD.PACKAGES_NOT_AVAILABLE' | transloco }}</div>
    </div>

    <div class="flex flex-col justify-center items-center" *ngIf="!isLoading && externalPackages?.length > 0 && !selectedExternalPackage">
      <div class="flex m-20 choose-tenant">{{'INSTANCE_DETAILS.CHOOSE_CUSTOM_PACKAGE_VIEW' | transloco}}</div>
    </div>

    <ng-container *ngIf="selectedExternalPackage">
      <div class="flex flex-col update-build">
        <div *ngIf="componentsData?.length > 0; else noDataFound" class="flex flex-col border-radius">
          <div class="component-header mat-body-2 fw-700 pl-50 flex items-center">{{'INSTANCE_DETAILS.UPDATE_BUILD.COMPONENT' | transloco | uppercase }}</div>
          <mat-accordion #accordion [togglePosition]="'before'" [multi]="false">
            <ng-container *ngFor="let component of componentsData">
              <mat-expansion-panel (afterExpand)="onArrowClick(component)">
                <mat-expansion-panel-header class="component">
                  <mat-panel-title>
                    <span class="mat-body-1 fw-500">{{ component?.component | titlecase }}</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="flex flex-row w-100-percent gap-4">
                  <div class="table-section package-sections p-16">
                    <span class="mat-body-2 fw-600 flex mb-12">{{'INSTANCE_DETAILS.UPDATE_BUILD.IMAGES' | transloco}}</span>
                    <ng-container *ngIf="dataSourceInner?.length > 0; else noInnerDataFound">
                      <div class="table-scroll">
                        <table mat-table [dataSource]="dataSourceInner" multiTemplateDataRows class="mat-elevation ext-package">
                          <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 name">{{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }}</th>
                            <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 name">
                              <div class="overflow" title="{{data?.name | titlecase}}">{{data?.name ? (data?.name | titlecase) : '-'}}</div></td>
                          </ng-container>
                          <ng-container matColumnDef="path">
                            <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 path">{{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }}</th>
                            <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 path"><div class="overflow" title="{{data?.path | titlecase}}">{{data?.path ? (data?.path | titlecase) : '-'}}</div></td>
                          </ng-container>
                          <ng-container matColumnDef="version">
                            <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.VERSION' | transloco | uppercase }} </th>
                            <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 version"><div class="p-4">{{data?.version ? (data?.version | titlecase) : '-'}}</div></td>
                          </ng-container>
                          <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
                        </table>
                      </div>
                    </ng-container>
                  </div>
                  <div class="table-section package-sections p-16">
                    <span class="mat-body-2 fw-600 flex mb-12">{{'INSTANCE_DETAILS.UPDATE_BUILD.PACKAGES' | transloco}}</span>
                    <ng-container *ngIf="dataSourceInnerPackages?.length > 0; else noInnerDataFound">
                      <div class="table-scroll">
                        <table mat-table [dataSource]="dataSourceInnerPackages" multiTemplateDataRows class="mat-elevation ext-package">
                          <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 name"> {{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }} </th>
                            <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 name">
                              <div class="overflow" title="{{data?.name | titlecase}}">{{data?.name ? (data?.name | titlecase) : '-'}}</div></td>
                          </ng-container>
                          <ng-container matColumnDef="path">
                            <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 path"> {{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }} </th>
                            <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 path"><div class="overflow" title="{{data?.path | titlecase}}">{{data?.path ? (data?.path | titlecase) : '-'}}</div></td>
                          </ng-container>
                          <ng-container matColumnDef="version">
                            <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.VERSION' | transloco | uppercase }} </th>
                            <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 version"><div class="p-4">{{data?.version ? (data?.version | titlecase) : '-'}}</div></td>
                          </ng-container>
                          <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
                        </table>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </mat-expansion-panel>
            </ng-container>
          </mat-accordion>
        </div>
        <ng-template #noDataFound>
          <div *ngIf="selectedExternalPackage" class="flex justify-center pt-8 pb-8 fw-400">
            {{'INSTANCE_DETAILS.UPDATE_BUILD.NO_COMPONENTS_AVALIABLE' | transloco }}
          </div>
        </ng-template>
        <ng-template #noInnerDataFound>
          <div>
            <table [dataSource]="dataSourceInnerLog" mat-table class="mat-elevation ext-package">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 name"> {{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }} </th>
              </ng-container>
              <ng-container matColumnDef="path">
                <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 path"> {{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }} </th>
              </ng-container>
              <ng-container matColumnDef="version">
                <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.TARGET_VERSION' | transloco | uppercase }} </th>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
            </table>
            <div class="flex justify-center items-center fw-500 mb-20 no-data">
              {{'INSTANCE_DETAILS.UPDATE_BUILD.NO_DATA_AVAILABLE' | transloco }}
            </div>
          </div>
        </ng-template>
      </div>
    </ng-container>

  </div>

</div>
  